import { render, staticRenderFns } from "./TriggersView.vue?vue&type=template&id=6230a9c3"
import script from "./TriggersView.vue?vue&type=script&lang=js"
export * from "./TriggersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports